import { Search } from 'lucide-react'
import { CHAMP } from '../synchro'

/** Champ de recherche avec loupe. `libelle` est le nom accessible (il commence par « Rechercher »). */
export function ChampRecherche({ libelle, placeholder, value, onChange }: { libelle: string; placeholder: string; value: string; onChange: (v: string) => void }) {
  return (
    <div className="relative">
      <Search aria-hidden className="pointer-events-none absolute top-1/2 left-3 size-5 -translate-y-1/2 text-slate-600" />
      <input
        className={`${CHAMP} bg-white pl-11`}
        type="search"
        aria-label={libelle}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete="off"
      />
    </div>
  )
}
